module.exports = __webpack_public_path__ + "media/images/emblems/Bachs-coat_of_arms-78f234cb65a23d1692c47c11ea271ba1.svg";